DJ.addBehavior('textLimited', '[data-text-slpitted]', {
  attach: function(context, settings, behavior) {
    var holder = jQuery(this);
    var limitHeight = parseFloat(holder.data('text-slpitted')) || 140;
    var padding = parseFloat(holder.css('paddingTop')) + parseFloat(holder.css('marginTop'));
    holder.attr('style', '--split-height: ' + (limitHeight - padding) + 'px');
    if (holder.height() > limitHeight) {
      holder.prepend("<div class='pb_wrapper'><div class='pagebreak'></div></div>");
    }
  },
  detach: function(context, settings) {}
});
